import React, { useState, useEffect } from 'react'
import { apiPath1 } from "../services/apiConfig"
import OverlappingLines from './DrawOverLappedLines'
import rupee from '../asset/icons/rupee-12.png'
import '../asset/css/dashboard.css';

export default function Overview() {
  const token = localStorage.getItem('token');
  const [heavyToolOverView, setHeavyToolOverview] = useState([]);
  const [toolOverView, setToolOverview] = useState([]);
  const [consumableOverView, setConsumableOverview] = useState([]);

  const len_base_line = 150;

  const color_base_line = "#EBEBEB";
  const color_data_line_ht = "#7530F3";
  const color_data_line_tool = "#17BEBB";
  const color_data_line_consumable = "#d68b00";

  const X = 0;
  const Y = 5;

  // Fetch Heavy Tool Overview
  useEffect(() => {
    async function fetchHeavyToolOverview() {
      try {
        const response = await fetch(apiPath1 + "HeavyToolsOverview", {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
          },
        });
        const result = await response.json();
        if (result.status !== true) {
          throw new Error('Failed to fetch heavy tool overview');
        }
        setHeavyToolOverview(result.data);
      } catch (error) {
        console.error("Error fetching heavy tool overview:", error);
        return;
      }

    }
    fetchHeavyToolOverview();
  }, []);

  // Fetch Tool Overview
  useEffect(() => {
    async function fetchToolOverview() {
      try {
        const response = await fetch(apiPath1 + "ToolsOverview", {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
          },
        });
        const result = await response.json();
        if (result.status !== true) {
          throw new Error('Failed to fetch tool overview');
        }
        setToolOverview(result.data);
      } catch (error) {
        console.error("Error fetching tool overview:", error);
        return;
      }

    }
    fetchToolOverview();
  }, []);

  // Fetch Consumable Overview
  useEffect(() => {
    async function fetchConsumableverview() {
      try {
        const response = await fetch(apiPath1 + "ConsumableOverview", {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
          },
        });
        const result = await response.json();
        if (result.status !== true) {
          throw new Error('Failed to fetch Consumable overview');
        }
        setConsumableOverview(result.data);
      } catch (error) {
        console.error("Error fetching Consumable overview:", error);
        return;
      }

    }
    fetchConsumableverview();
  }, []);

  // Calculate 3 total cost as fraction of 150, the length of base line
  const totCost = heavyToolOverView.HeavyToolCost + toolOverView.ToolCost + consumableOverView.ConsumableCost;
  const frac_ht_cost = (heavyToolOverView.HeavyToolCost / totCost) * len_base_line;
  const frac_tool_cost = (toolOverView.ToolCost / totCost) * len_base_line;
  const frac_consumable_cost = (consumableOverView.ConsumableCost / totCost) * len_base_line;

  const frac_ht_inuse_cost = (heavyToolOverView.HeavyToolInUseCost / heavyToolOverView.HeavyToolCost) * len_base_line;
  const frac_tool_inuse_cost = (toolOverView.ToolInUseCost / toolOverView.ToolCost) * len_base_line;
  const frac_consumable_inuse_cost = (consumableOverView.ConsumableInUseCost / consumableOverView.ConsumableCost) * len_base_line;

  const frac_ht_damaged_cost = (heavyToolOverView.HeavyToolDamagedCost / heavyToolOverView.HeavyToolCost) * len_base_line;
  const frac_tool_damaged_cost = (toolOverView.ToolDamagedCost / toolOverView.ToolCost) * len_base_line;
  const frac_consumable_damaged_cost = (consumableOverView.ConsumableDamagedCost / consumableOverView.ConsumableCost) * len_base_line;

  const frac_ht_inrepair_cost = (heavyToolOverView.HeavyToolInRepairCost / heavyToolOverView.HeavyToolCost) * len_base_line;

  return (
    <>
      <div className="row mt8">
        <div className="c12-l-12">
          <div className="cont__dashboard-overview">
            <h5 className="md mb8">Overview</h5>

            <div className="row">
              {/* Total Inventory ---------------- */}
              <div className="c12-g-l-4 box corner-round box-shadow px16">
                <p className="bold txt-darkblue my8">Total Inventory</p>

                {/* Heavy Tool */}
                <div className="cont__dashboard-overview-component">
                  <div className="c12-g-l-2">
                    <div className="cont-round htool">
                      <p className="sm wide bold color-contrast-light">H</p>
                    </div>
                  </div>

                  <div className="c12-g-l-3 mid-left">
                    <p className="lg bold">
                      {heavyToolOverView.HeavyToolCnt}
                    </p>
                  </div>

                  <div className="c12-l-7">
                    <div className='row '>
                      <div className="c12-l-6">
                        <p className="sm medium">Heavy Tools</p>
                      </div>

                      <div className="c12-l-6 ">
                        <div className='middle-right'>
                          <img src={rupee} alt="Rupee" />
                          <span className="sm right">
                            {heavyToolOverView.HeavyToolCost}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className='cont-overlap-lines'>
                      <OverlappingLines
                        baseLineLength={len_base_line}
                        dataLineLength={frac_ht_cost}
                        baseLineColor={color_base_line}
                        dataLineColor={color_data_line_ht}
                        x={X}
                        y={Y}
                      />
                    </div>
                  </div>
                </div>

                {/* Other Tool */}
                <div className="cont__dashboard-overview-component">
                  <div className="c12-g-l-2">
                    <div className="cont-round tool">
                      <p className="sm wide bold color-contrast-light">T</p>
                    </div>
                  </div>

                  <div className="c12-g-l-3 mid-left">
                    <p className="lg bold">
                      {toolOverView.ToolCnt}
                    </p>
                  </div>

                  <div className="c12-l-7 ">
                    <div className='row '>
                      <div className="c12-l-6">
                        <p className="sm medium">Tools</p>
                      </div>

                      <div className="c12-l-6 ">
                        <div className='middle-right'>
                          <img src={rupee} alt="Rupee" />
                          <span className="sm right">
                            {toolOverView.ToolCost}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className='cont-overlap-lines'>
                      <OverlappingLines
                        baseLineLength={len_base_line}
                        dataLineLength={frac_tool_cost}
                        baseLineColor={color_base_line}
                        dataLineColor={color_data_line_tool}
                        x={X}
                        y={Y}
                      />
                    </div>
                  </div>
                </div>

                {/* Consumable */}
                <div className="cont__dashboard-overview-component">
                  <div className="c12-g-l-2">
                    <div className="cont-round consumable">
                      <p className="sm wide bold color-contrast-light">C</p>
                    </div>
                  </div>

                  <div className="c12-g-l-3 mid-left">
                    <p className="lg bold">
                      {consumableOverView.ConsumableCnt}
                    </p>
                  </div>

                  <div className="c12-l-7 ">
                    <div className='row '>
                      <div className="c12-l-6">
                        <p className="sm medium">Consumables</p>
                      </div>

                      <div className="c12-l-6 ">
                        <div className='middle-right'>
                          <img src={rupee} alt="Rupee" />
                          <span className="sm right">
                            {consumableOverView.ConsumableCost}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className='cont-overlap-lines'>
                      <OverlappingLines
                        baseLineLength={len_base_line}
                        dataLineLength={frac_consumable_cost}
                        baseLineColor={color_base_line}
                        dataLineColor={color_data_line_consumable}
                        x={X}
                        y={Y}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Damaged / Rejected Inventory ----------------- */}
              <div className="c12-g-l-4 box corner-round box-shadow px16">
                <p className="bold txt-darkblue my8">Damaged and Rejected Inventory</p>

                {/* Heavy Tool */}
                <div className="cont__dashboard-overview-component">
                  <div className="c12-g-l-2">
                    <div className="cont-round htool">
                      <p className="sm wide bold color-contrast-light">H</p>
                    </div>
                  </div>

                  <div className="c12-g-l-3 mid-left">
                    <p className="lg bold">
                      {heavyToolOverView.HeavyToolDamagedCnt}
                    </p>
                  </div>

                  <div className="c12-l-7">
                    <div className='row '>
                      <div className="c12-l-6">
                        <p className="sm medium">Heavy Tools</p>
                      </div>

                      <div className="c12-l-6 ">
                        <div className='middle-right'>
                          <img src={rupee} alt="Rupee" />
                          <span className="sm right color-warning">
                            {heavyToolOverView.HeavyToolDamagedCost}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className='cont-overlap-lines'>
                      <OverlappingLines
                        baseLineLength={len_base_line}
                        dataLineLength={frac_ht_damaged_cost}
                        baseLineColor={color_base_line}
                        dataLineColor={color_data_line_ht}
                        x={X}
                        y={Y}
                      />
                    </div>
                  </div>
                </div>

                {/* Other Tool */}
                <div className="cont__dashboard-overview-component">
                  <div className="c12-g-l-2">
                    <div className="cont-round tool">
                      <p className="sm wide bold color-contrast-light">T</p>
                    </div>
                  </div>

                  <div className="c12-g-l-3 mid-left">
                    <p className="lg bold">
                      {toolOverView.ToolDamagedCnt}
                    </p>
                  </div>

                  <div className="c12-l-7">
                    <div className='row '>
                      <div className="c12-l-6">
                        <p className="sm medium">Tools</p>
                      </div>

                      <div className="c12-l-6 ">
                        <div className='middle-right'>
                          <img src={rupee} alt="Rupee" />
                          <span className="sm right color-warning">
                            {toolOverView.ToolDamagedCost}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className='cont-overlap-lines'>
                      <OverlappingLines
                        baseLineLength={len_base_line}
                        dataLineLength={frac_tool_damaged_cost}
                        baseLineColor={color_base_line}
                        dataLineColor={color_data_line_tool}
                        x={X}
                        y={Y}
                      />
                    </div>
                  </div>
                </div>

                {/* Consumable */}
                <div className="cont__dashboard-overview-component">
                  <div className="c12-g-l-2">
                    <div className="cont-round consumable">
                      <p className="sm wide bold color-contrast-light">C</p>
                    </div>
                  </div>

                  <div className="c12-g-l-3 mid-left">
                    <p className="lg bold">
                      {consumableOverView.ConsumableDamagedCnt}
                    </p>
                  </div>

                  <div className="c12-l-7">
                    <div className='row '>
                      <div className="c12-l-6">
                        <p className="sm medium">Consumables</p>
                      </div>

                      <div className="c12-l-6 ">
                        <div className='middle-right'>
                          <img src={rupee} alt="Rupee" />
                          <span className="sm right color-warning">
                            {consumableOverView.ConsumableDamagedCost}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className='cont-overlap-lines'>
                      <OverlappingLines
                        baseLineLength={len_base_line}
                        dataLineLength={frac_consumable_damaged_cost}
                        baseLineColor={color_base_line}
                        dataLineColor={color_data_line_consumable}
                        x={X}
                        y={Y}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* In-repair Inventory ----------------- */}
              <div className="c12-g-l-4 box corner-round box-shadow px16">
                <p className="bold txt-darkblue my8">Inventory In-Repair</p>

                {/* Heavy Tool */}
                <div className="cont__dashboard-overview-component">
                  <div className="c12-g-l-2">
                    <div className="cont-round htool">
                      <p className="sm wide bold color-contrast-light">H</p>
                    </div>
                  </div>

                  <div className="c12-g-l-3 mid-left">
                    <p className="lg bold">
                      {heavyToolOverView.HeavyToolInRepairCnt}
                    </p>
                  </div>

                  <div className="c12-l-7">
                    <div className='row '>
                      <div className="c12-l-6">
                        <p className="sm medium">Heavy Tools</p>
                      </div>

                      <div className="c12-l-6 ">
                        <div className='middle-right'>
                          <img src={rupee} alt="Rupee" />
                          <span className="sm right">
                            {heavyToolOverView.HeavyToolInRepairCost}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className='cont-overlap-lines'>
                      <OverlappingLines
                        baseLineLength={len_base_line}
                        dataLineLength={frac_ht_inrepair_cost}
                        baseLineColor={color_base_line}
                        dataLineColor={color_data_line_ht}
                        x={X}
                        y={Y}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>

  )
}
